module.exports = __webpack_public_path__ + "static/media/2.699360f0.png";